import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from "../Icon";
import { MORE_FILTERS } from "../../../utils/default-strings";
export var Component = function Component(_ref) {
  var onFiltersClick = _ref.onFiltersClick,
      onClearFiltersClick = _ref.onClearFiltersClick,
      filterTriggerText = _ref.filterTriggerText,
      hasFiltersSelected = _ref.hasFiltersSelected;
  return React.createElement("div", {
    className: classNames('filter-trigger', {
      'has-filter': !!hasFiltersSelected
    })
  }, React.createElement("button", {
    onClick: onFiltersClick
  }, React.createElement(Icon, {
    labelText: filterTriggerText,
    name: "filter"
  })), hasFiltersSelected && React.createElement("button", {
    onClick: onClearFiltersClick
  }, React.createElement(Icon, {
    name: "close"
  })));
};
Component.displayName = 'FilterTrigger';
Component.defaultProps = {
  filterTriggerText: MORE_FILTERS,
  hasFiltersSelected: false,
  onClearFiltersClick: Function.prototype,
  onFiltersClick: Function.prototype
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  filterTriggerText: PropTypes.string,
  hasFiltersSelected: PropTypes.bool,
  onClearFiltersClick: PropTypes.func,
  onFiltersClick: PropTypes.func
} : {};